import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\GetUserTokensController::__invoke
* @see app/Http/Controllers/User/GetUserTokensController.php
* @route '/api/user/{user}/tokens'
*/
const GetUserTokensController = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetUserTokensController.url(args, options),
    method: 'get',
})

GetUserTokensController.definition = {
    methods: ["get","head"],
    url: '/api/user/{user}/tokens',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\GetUserTokensController::__invoke
* @see app/Http/Controllers/User/GetUserTokensController.php
* @route '/api/user/{user}/tokens'
*/
GetUserTokensController.url = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return GetUserTokensController.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\GetUserTokensController::__invoke
* @see app/Http/Controllers/User/GetUserTokensController.php
* @route '/api/user/{user}/tokens'
*/
GetUserTokensController.get = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetUserTokensController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\GetUserTokensController::__invoke
* @see app/Http/Controllers/User/GetUserTokensController.php
* @route '/api/user/{user}/tokens'
*/
GetUserTokensController.head = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetUserTokensController.url(args, options),
    method: 'head',
})

export default GetUserTokensController